import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useConfig } from "../../state";

import { BackToSearchButton } from "../../components/BackToSearchButton";
import { CloseButton } from "../../components/CloseButton";
import { zoomTo } from "../../map/util";
import { Cube } from "../../state/types";
import { fCoords } from "./util";

const Wrapper = ({ children = null }) => (
  <div
    className="h-52 flex flex-col justify-end text-white rounded-t-2xl sm:rounded-none"
    style={{ backgroundColor: "rgb(78, 100, 90, 90%)" }}
  >
    {children}
  </div>
);

const BGImage = ({ field, coords }: { field: Cube; coords?: string }) => {
  const config = useConfig();

  const gps = coords ?? fCoords(field.center, ",");
  const img = `${config.referenceUrl}/api/image/cadastre?c=${gps}&width=432&height=208`;
  const img2x = `${config.referenceUrl}/api/image/cadastre?c=${gps}&width=864&height=416`;

  return (
    <img
      onClick={() => zoomTo(window["map"], field.geometry)}
      className="rounded-t-2xl sm:rounded-none h-full object-stretch sm:object-none"
      src={img}
      alt=""
      srcSet={`${img} 1x, ${img2x} 2x`}
    />
  );
};

export const SectionHero = ({ field, coords }: { field: Cube; coords?: string }) => {
  if (!field) return <Wrapper />;

  const { project } = field;
  const address = field.addresses?.[0];
  const label1 = project || (address ? address.street + " " + address.number : field.name);
  const label2 = address?.city;

  if (!field) return <Wrapper />;

  return (
    <Wrapper>
      <FontAwesomeIcon
        icon={faBars}
        stroke="currentColor"
        preserveAspectRatio="none"
        className="sm:invisible top-0 absolute justify-self-auto h-6 pl-2 opacity-70"
        style={{ width: "calc(100vw - 60px)" }}
      />
      <BackToSearchButton />
      <CloseButton />
      <div className="absolute p-4 z-10">
        <h1 className="font-bold text-shadow-2 text-2xl">{label1}</h1>
        <h2 className="text-xl text-shadow">
          {label2 ? `${label2}, ` : ""}
          {field.administrative.zone2?.name}
        </h2>
      </div>
      <BGImage field={field} coords={coords} />
    </Wrapper>
  );
};
